module.exports = __webpack_public_path__ + "img/card1.png?47eab866527083267125c961289a3d08";